import React from 'react';

/**
 * <PersonName> — prikaz imena partnera s automatskom blur-anonimizacijom.
 *
 * Backend (AnonymizePersonNames middleware) već maskira stringove fizičkih osoba u
 * "M*** M*****ć" obliku i šalje paralelno `{field}_is_person: true` flag. Ova komponenta
 * dodatno aplicira CSS blur preko imena ako je flag postavljen — vizualna brava preko
 * tekstualne maske.
 *
 * Naše tvrtke (iz `bi_companies`) i registrirani entiteti s pravnim sufiksom (d.o.o., GmbH,
 * Ltd...) NE prolaze kroz transformaciju → prikazuju se kao plain text.
 *
 * Korištenje:
 *   <PersonName value={row.partner_name} isPerson={row.partner_name_is_person} />
 *
 * Bilo gdje gdje se prikazuju imena partnera. Ne diraj stringove direktno —
 * uvijek koristi ovu komponentu.
 */
export function PersonName({
    value,
    isPerson = false,
    hint,
    style,
    fallback = '—',
}: {
    value: string | null | undefined;
    isPerson?: boolean;
    hint?: string | null;
    style?: React.CSSProperties;
    fallback?: string;
}) {
    if (!value || value === '') {
        return <span style={style}>{fallback}</span>;
    }
    if (!isPerson) {
        return <span style={style}>{value}</span>;
    }
    // Maskirano + blur. User-select=none → ne može copy/paste raw mask.
    return (
        <span
            title={hint ? `Anonimizirano (${hint})` : 'Anonimizirano (fizička osoba)'}
            style={{
                filter: 'blur(3px)',
                userSelect: 'none',
                cursor: 'help',
                fontVariantLigatures: 'none',
                ...style,
            }}
        >
            {value}
        </span>
    );
}
